module.exports = __webpack_public_path__ + "static/fig-05-b3365086ee9197751e217d6e0c548c3b.png";